import classnames from "classnames"
import PropTypes from "prop-types"
import PieChart from "react-simple-pie-chart"
import Pathicon from "../pathicon/Pathicon"
import { useUIThemeContext } from "../ui/PathwrightUI"
import { PRIMARY_GRAY } from "../utils/colors"
import "./ProgressPieChart.css"

const ProgressPieChart = (props, context) => {
  const { progress, locked, inverted, size } = props
  const className = classnames(
    "ProgressPieChart",
    {
      "ProgressPieChart--filled": locked || progress >= 1,
      "ProgressPieChart--inverted": inverted
    },
    props.className
  )
  const theme = useUIThemeContext()
  const backColor = inverted ? "rgba(0,0,0,0.1)" : "#ddd"
  const fillColor = inverted ? "rgba(255,255,255,0.5)" : theme.primaryBrandColor
  const pathiconColor = inverted ? "rgba(255,255,255,0.5)" : PRIMARY_GRAY
  const wrapStyle = {
    width: `${size}px`,
    height: `${size}px`,
    borderRadius: `${size / 2}px`,
    backgroundColor: locked || progress >= 1 ? backColor : null
  }

  return (
    <div className={className} style={wrapStyle}>
      {locked ? (
        <Pathicon icon="lock" style={{ color: pathiconColor }} />
      ) : progress < 1 ? (
        <PieChart
          slices={[
            { color: backColor, value: 1 - progress },
            { color: fillColor, value: progress }
          ]}
        />
      ) : (
        <Pathicon icon="check" style={{ color: pathiconColor }} />
      )}
    </div>
  )
}

ProgressPieChart.displayName = "ProgressPieChart"

ProgressPieChart.propTypes = {
  size: PropTypes.number
}

ProgressPieChart.defaultProps = {
  size: 16
}

export default ProgressPieChart
